<template>
  <b-carousel v-if="formattedImages.length > 0" :autoplay="false" indicator-custom :indicator-inside="false" :overlay="gallery" @click="switchGallery(true)">
      <b-carousel-item class="hero-body has-text-centered" v-for="image in formattedImages" :key="image.url">
          <a class=" carousel-image is-hidden-touch" >
              <img :src="image.url" class="is-clickable" style="object-fit:cover;" @click="imageModal(image.url)">
          </a>
          <a class="image is-hidden-desktop" style="height: 40vh;">
              <img :src="image.url">
          </a>
          <div class="carousel-image-caption has-text-grey">{{image.description}}</div>
      </b-carousel-item>
      <span v-if="gallery" @click="switchGallery(false)" class="modal-close is-large"/>
      <template #indicators="props">
          <figure class="al image" :draggable="false">
              <img :draggable="false" :src="getImgUrl(props.i)" :title="props.i">
          </figure>
      </template>
  </b-carousel>
  <div v-else>
    No pictures Available
  </div>
</template>

<script>
export default {
  name: 'HotelDetailImages',
  props: {
    images: {
      type: Array
    },
  },
  data() {
    return {
      cooloff: new Date(),
      gallery: false,
    }
  },
  computed: {
    formattedImages() {
      let formattedImages = [];
      for (const [key, value] of Object.entries(this.images)) {
        // console.log(key, value);
        if(value.url){
          formattedImages.push(value);
        }
      }
      return formattedImages;
    }
  },
  methods: {
    imageModal(image) {
        var time = new Date()
        // console.log(this.cooloff)
        if (time - this.cooloff > 1000) {
          this.cooloff = time
          const h = this.$createElement
          const vnode = h('p', { class: "image", style: "width: 50vw; hieght: 50vh;" }, [
              h('img', { attrs: { src: image }})
          ])
          this.$buefy.modal.open({
              content: [ vnode ]
          })

        }

    },
    getImgUrl(value) {
            return this.images[value].url
        },
    switchGallery(value) {
        this.gallery = value
        if (value) {
            return document.documentElement.classList.add('is-clipped')
        } else {
            return document.documentElement.classList.remove('is-clipped')
        }
    }
  },
}
</script>

<style lang="css" scoped>
  .is-active .al img {
      border: 1px solid #fff;
      filter: grayscale(0%);
  }
  .al img {
      border: 1px solid transparent;
      filter: grayscale(100%);
  }
  .carousel {
    height: 300px;
  }
  .carousel-item {
    height: 350px;
  }
  .carousel-image {
    max-height: 300px;
    max-width: 100%;
  }
  .carousel-image-caption {
    position: absolute;
    bottom: 0;
    text-align: center;
    left: 0;
    right: 0;
    padding: 10px;
  }
</style>
